import queryClient from '../query-client';
import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';

async function removeYIEntityMapping(entityId: string): Promise<void> {
    await api.delete(`/fyi-docs/entity-mapping/${entityId}`);
}

export function useRemoveFYIEntityMapping(entityId: string): UseMutationResult<void, AxiosError, string, unknown> {
    return useMutation(() => removeYIEntityMapping(entityId), {
        onSettled: () => {
            queryClient.invalidateQueries(['fyi', 'entities']);
            queryClient.invalidateQueries(['entities', entityId]);
        },
    });
}
